<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.75 13.125L14.9375 8.9375L16 10L10 16L4 10L5.0625 8.9375L9.25 13.125L9.25 4L10.75 4L10.75 13.125Z" fill="#333333"/>
</svg>
